import "./service_box.scss";
const ServiceBox = (service) => {
  const serviceInfo = service.service;

  return (
    <div className={`service_box_main box_${serviceInfo.id}`}>
      <div className={`service_box_icon icon_${serviceInfo.id}`}>
        {serviceInfo?.icon && <serviceInfo.icon />}
        {serviceInfo?.img && (
          <img src={serviceInfo.img} alt="Halal Certification" />
        )}
      </div>
      <div className="service_box_name">
        <h6>{serviceInfo.name}</h6>
      </div>
    </div>
  );
};

export default ServiceBox;
